import { render } from "./SchedaContenuto.vue?vue&type=template&id=6a300b18"
import script from "./SchedaContenuto.vue?vue&type=script&lang=js"
export * from "./SchedaContenuto.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__